<section class="services-section" id="services">
  <div class="container">
    <div class="services-grid">
      <!-- Kártya 1 -->
      <div class="service-card">
        <img src="assets/images/vagott-virag.jpg" alt="Vágott virágok">
        <div class="service-info">
          <h3>{{ 'own-services.cutted-flower.title' | translate }}</h3>
          <p>{{ 'own-services.cutted-flower.description' | translate }}</p>
        </div>
        <div class="service-overlay">
          <p>{{ 'own-services.cutted-flower.overlay' | translate }}</p>
        </div>
      </div>

      <!-- Kártya 2 -->
      <div class="service-card">
        <img src="assets/images/tavaszi_csokor.jpg" alt="Egyedi csokrok">
        <div class="service-info">
          <h3>{{ 'own-services.unique-bouqet.title' | translate }}</h3>
          <p>{{ 'own-services.unique-bouqet.description' | translate }}</p>
        </div>
        <div class="service-overlay">
          <p>{{ 'own-services.unique-bouqet.overlay' | translate }}</p>
        </div>
      </div>

      <!-- Kártya 3 -->
      <div class="service-card">
        <img src="assets/images/orchidea.jpg" alt="Cserepes virágok">
        <div class="service-info">
          <h3>{{ 'own-services.flower-in-pot.title' | translate }}</h3>
          <p>{{ 'own-services.flower-in-pot.description' | translate }}</p>
        </div>
        <div class="service-overlay">
          <p>{{ 'own-services.flower-in-pot.overlay' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
